var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C14.957 1.25 19 5.29297 19 10.25C19 15.2422 14.957 19.25 10 19.25C5.00781 19.25 1 15.2422 1 10.25C1 5.29297 5.00781 1.25 10 1.25ZM10 17.5625C14.0078 17.5625 17.3125 14.293 17.3125 10.25C17.3125 6.24219 14.0078 2.9375 10 2.9375C5.95703 2.9375 2.6875 6.24219 2.6875 10.25C2.6875 14.293 5.95703 17.5625 10 17.5625ZM10 11.9375C9.50781 11.9375 9.15625 11.5859 9.15625 11.0938V6.59375C9.15625 6.13672 9.50781 5.75 10 5.75C10.457 5.75 10.8438 6.13672 10.8438 6.59375V11.0938C10.8438 11.5859 10.457 11.9375 10 11.9375ZM10 13.1328C10.5977 13.1328 11.0898 13.625 11.0898 14.2227C11.0898 14.8203 10.5977 15.3125 10 15.3125C9.36719 15.3125 8.875 14.8203 8.875 14.2227C8.875 13.625 9.36719 13.1328 10 13.1328Z",
    fill: "#D83D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.7eda5cc78be46a38dfcaf4a418aaf384.svg";
export { ForwardRef as ReactComponent };